import React from 'react';
import styles from './Loader.module.scss';
import { LottieAnimation } from '../LottieAnimation';
import loadingAnimation from '@/assets/loading.json';

export const Loader: React.FC = () => {
  return (
    <div className={styles.loader}>
      <LottieAnimation
        animationData={loadingAnimation}
        style={{ width: '104px', height: '104px' }}
        loop={true}
        autoplay={true}
      />
    </div>
  );
};
